import Link from "next/link";
import { formatISODateString } from "~/utils/dateFormat";

const PostDataNumber = ({ issuem_issue, data_post }) => {
  return (
    <span className="mb-3 block uppercase lg:text-lg">
      <Link
        className="font-bold text-orange hover:underline"
        href={`/n/${issuem_issue.slug}`}
      >
        {issuem_issue.slug}
      </Link>{" "}
      / {formatISODateString(data_post)}
    </span>
  );
};

export default PostDataNumber;
